// import SHA1 from '@/public/SHA1';
var SHA1 = require('sha1');
import { getCookie, setCookie, getUrlVars } from '@/public/functions';


export const initImpactCookie = () => {
    let impact_partnerID = getUrlVars()['partner_id'];
    let impact_clickID = '';
    let impact_sharedID = '';
    if (getUrlVars()['clickid'] !== undefined && getUrlVars()['clickid'].length) {
        impact_clickID = getUrlVars()['clickid'];
    }

    if (getUrlVars()['shared_id'] !== undefined && getUrlVars()['shared_id'].length) {
        impact_sharedID = getUrlVars()['shared_id'];
    }

    let impact_orderID = 'O' + impact_clickID;
    let impact_customerID = 'C' + impact_clickID;



    setCookie("impact_partnerID", impact_partnerID, 90);
    setCookie("impact_clickID", impact_clickID, 90);
    setCookie("impact_orderID", impact_orderID, 90);
    setCookie("impact_customerID", impact_customerID, 90);
    setCookie("impact_sharedID", impact_sharedID, 90);
}


export const impactLeadPixel = (pixelID, email) => {

    (function (email) {
        const impact_customerEmail = SHA1(email);
        const impact_orderID = getCookie('impact_orderID');
        const impact_customerID = getCookie('impact_customerID');
        const impact_clickID = getCookie('impact_clickID');

        ire('trackConversion', pixelID, {
            orderId: impact_orderID,
            clickId: impact_clickID,
            customerId: impact_customerID,
            customerEmail: impact_customerEmail,
            currencyCode: "USD"
        }, { verifySiteDefinitionMatch: true });
        console.log('impact tracking, and email: ' + impact_customerEmail + ' orderId: ' + impact_orderID + ' cusId: ' + impact_customerID + 'clickId: ' + impact_clickID);

    })(email);


}

